import React from "react";
import "./Divider.css";

export function Divider() {
  return <div className="divider" />;
}
